// removed by extract-text-webpack-plugin
module.exports = {"fixed":"_1MP7q","back-button":"_2kLVt","mobile-bar":"_5axfW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PageOwner/PageOwnerNavbar.scss
// module id = ./src/components/PageOwner/PageOwnerNavbar.scss
// module chunks = 5